import { useCookie } from './useCookie';

const GOOGLE_CLICK_ID_KEY = 'gclid';

export const useGoogleClickID = () => useCookie(GOOGLE_CLICK_ID_KEY).cookie;
